
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"currentColor","viewBox":"0 0 21 21","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.5 6a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm-3.446-3.118H4.467A3.382 3.382 0 002.018 3.96 3.793 3.793 0 001 6.553a3.793 3.793 0 001.018 2.593 3.381 3.381 0 002.449 1.077h9.066a3.382 3.382 0 002.449-1.078 3.77 3.77 0 00.995-2.177 3.531 3.531 0 01-1.497-.119 2.268 2.268 0 01-.589 1.266 1.883 1.883 0 01-1.36.608H4.469a1.882 1.882 0 01-1.36-.607A2.293 2.293 0 012.5 6.553c.003-.601.23-1.162.609-1.563a1.883 1.883 0 011.36-.608h8.643a3.506 3.506 0 01-.058-1.5zm-8.92 3.67c0 .186.034.37.1.541.068.171.166.327.29.458.124.131.27.235.432.306a1.27 1.27 0 001.02 0c.163-.07.31-.175.433-.306a1.42 1.42 0 00.29-.458 1.484 1.484 0 000-1.08 1.42 1.42 0 00-.29-.458 1.33 1.33 0 00-.432-.306 1.27 1.27 0 00-1.02 0 1.33 1.33 0 00-.433.306 1.42 1.42 0 00-.29.458 1.484 1.484 0 00-.1.54zm.335 10.713h9.062c.493-.002.984-.21 1.36-.608.379-.401.606-.961.609-1.563a2.294 2.294 0 00-.609-1.562 1.884 1.884 0 00-1.36-.608H4.469c-.493.002-.984.21-1.36.608-.379.4-.606.96-.609 1.562.002.602.23 1.162.609 1.563.376.398.867.606 1.36.608zm-.002 1.5a3.382 3.382 0 01-2.449-1.078A3.792 3.792 0 011 15.094a3.793 3.793 0 011.018-2.592 3.382 3.382 0 012.449-1.079h9.066c.919.004 1.799.391 2.449 1.079A3.794 3.794 0 0117 15.094a3.793 3.793 0 01-1.018 2.592 3.382 3.382 0 01-2.449 1.079H4.467zm7.124-2.672a1.455 1.455 0 01-.391-.999c0-.374.14-.733.39-.998s.59-.414.943-.414c.354 0 .693.15.943.414.25.265.39.624.39.998 0 .375-.14.734-.39.999-.25.264-.59.413-.943.413s-.692-.149-.942-.413z"}})])
          )
        }
      }
    